import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";

const LoadingContext = createContext();

export const useLoading = () => {
  return useContext(LoadingContext);
};

export const LoadingProvider = ({ children }) => {
  // Legacy global flag (showLoading/hideLoading) plus per-owner tokens.
  // An owner (e.g. a Home init effect) acquires a token and releases only its
  // own on cleanup, so a cancelled event A can neither hide event B's overlay
  // nor leave it stranded.
  const [legacyLoading, setLegacyLoading] = useState(false);
  const [ownerCount, setOwnerCount] = useState(0);

  const showLoading = useCallback(() => setLegacyLoading(true), []);
  const hideLoading = useCallback(() => setLegacyLoading(false), []);

  const acquireLoading = useCallback(() => {
    let released = false;
    setOwnerCount((count) => count + 1);
    return () => {
      if (released) return;
      released = true;
      setOwnerCount((count) => Math.max(0, count - 1));
    };
  }, []);

  const value = useMemo(
    () => ({
      isLoading: legacyLoading || ownerCount > 0,
      showLoading,
      hideLoading,
      acquireLoading,
    }),
    [legacyLoading, ownerCount, showLoading, hideLoading, acquireLoading]
  );

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};
